import { Client, Conversation, Participant, Message, User } from "@twilio/conversations";
import { GenericThemeShape } from "@twilio-paste/theme";
import { AlertVariants } from "@twilio-paste/core/alert";

import { FileAttachmentConfig, TranscriptConfig } from "../definitions";

export enum EngagementPhase {
    PreEngagementForm = "PreEngagementForm",
    MessagingCanvas = "MessagingCanvas",
    Loading = "Loading"
}

export type ChatState = {
    conversationsClient?: Client;
    conversation?: Conversation;
    participants?: Participant[];
    users?: User[];
    messages?: Message[];
    attachedFiles?: File[];
    conversationState?: string;
    /* "Esperando o bot": trava input/botões e mostra o balão de digitando (ver TypingIndicator). */
    awaitingBot?: boolean;
    /* Trava fixa (~3s) ao iniciar a conversa, cobrindo o carregamento do fluxo. Timer, não evento. */
    welcomeInputLock?: boolean;
    /* Modo humano (pós-transbordo): atendente assumiu — nunca trava input nem mostra balão. */
    humanMode?: boolean;
};

export type PreEngagementData = { name: string; email: string; cpf: string };

export type SessionState = {
    currentPhase: EngagementPhase;
    expanded: boolean;
    token?: string;
    conversationSid?: string;
    conversationsClient?: Client;
    conversation?: Conversation;
    users?: User[];
    participants?: Participant[];
    messages?: Message[];
    conversationState?: "active" | "inactive" | "closed";
    preEngagementData?: PreEngagementData;
    preEngagementStep: number;
};

/* Posição configurável do launcher/janela (MVP: cantos inferiores). Contrato compartilhado com o dashboard. */
type LauncherCorner = "bottom-right" | "bottom-left";

export type LauncherPosition = {
    corner: LauncherCorner;
    offsetX: number; // px horizontal (right se *-right, left se *-left)
    offsetY: number; // px da borda inferior (bottom)
    sameOnMobile?: boolean; // usar a mesma posição no mobile (launcher). default true
};

export type ConfigState = {
    serverUrl?: string;
    theme?: {
        isLight?: boolean;
        overrides?: Partial<GenericThemeShape>;
    };
    fileAttachment?: FileAttachmentConfig;
    transcript?: TranscriptConfig;
    /* Logo do launcher resolvido em runtime (dashboard, por marca). Fallback: BRAND.launcherLogo. */
    launcherLogo?: string;
    /* Posição do launcher/janela (dashboard, runtime). Ausente = posição atual (bottom-right/20/19). */
    launcherPosition?: LauncherPosition;
    /* Arredondamento (px) da janela do chat. Ausente = 20px (atual). */
    borderRadius?: number;
    /* Título do cabeçalho (dashboard, runtime). Ausente/vazio = default da marca ("Suporte 24 horas"). */
    headerTitle?: string;
};

export type Notification = {
    dismissible: boolean;
    id: string;
    onDismiss?: () => void;
    message: string;
    timeout?: number;
    type: AlertVariants;
};

export type NotificationState = Notification[];

export type AppState = {
    chat: ChatState;
    config: ConfigState;
    session: SessionState;
    notifications: NotificationState;
};
